import React, { useState } from 'react';
import countries from 'world-countries';

export default function JoinUs() {
  const [primaryCountry, setPrimaryCountry] = useState('');
  const [secondaryCountry, setSecondaryCountry] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission (e.g., send to API)
    console.log({ primaryCountry, secondaryCountry, message });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center">
      {/* Hero Section */}
      <header className="w-full bg-white py-12 px-6 text-center shadow">
        <h1 className="text-4xl font-extrabold text-indigo-900">
          Publish a Biblical Name Book with the International Biblical Onomastic Society
        </h1>
        <p className="mt-4 text-xl text-gray-700 max-w-2xl mx-auto">
          Collaborate with us to create a unique Biblical Name Book across two languages, strengthen your community, and leave a lasting spiritual legacy — while sharing in the success.
        </p>
      </header>

      {/* Partnership Model Cards */}
      <section className="w-full max-w-7xl px-4 mt-12 grid gap-6 sm:grid-cols-1 md:grid-cols-3">
        {/* Card 1 */}
        <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
          <h3 className="text-2xl font-semibold text-indigo-800">Joint Venture Model 1</h3>
          <p className="mt-2 text-gray-600">
            Partner with us without upfront costs! We invest in completing the book, preparing marketing, and setting up a targeted crowdfunding campaign to support your project.
          </p>
          <ul className="mt-4 list-disc list-inside text-gray-700 space-y-2">
            <li>✔ No upfront payment (small setup contribution may apply)</li>
            <li>✔ 50% of crowdfunding proceeds after direct costs</li>
            <li>✔ 10% of further sales profits</li>
            <li>✔ Ideal for community fundraising and outreach</li>
          </ul>
        </div>

        {/* Card 2 */}
        <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
          <h3 className="text-2xl font-semibold text-indigo-800">Joint Venture Model 2</h3>
          <p className="mt-2 text-gray-600">
            Moderate investment, higher customization, and a share in profits — perfect for motivated partners wanting faster results.
          </p>
          <ul className="mt-4 list-disc list-inside text-gray-700 space-y-2">
            <li>✔ $999 contribution</li>
            <li>✔ 50% profit share (after production costs)</li>
            <li>✔ Exclusive edition rights for one year</li>
            <li>✔ Basic promotion package included</li>
          </ul>
        </div>

        {/* Card 3 */}
        <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
          <h3 className="text-2xl font-semibold text-indigo-800">Premium Investment</h3>
          <p className="mt-2 text-gray-600">
            Take full control of your edition with premium support, wide customization, and the highest royalty returns.
          </p>
          <ul className="mt-4 list-disc list-inside text-gray-700 space-y-2">
            <li>✔ $4,999 investment for full customization</li>
            <li>✔ 80% of profits for 5 years</li>
            <li>✔ Exclusive country rights</li>
            <li>✔ Premium marketing and sales package</li>
          </ul>
        </div>
      </section>

      {/* Signup Form */}
      <section className="w-full bg-indigo-100 mt-16 py-12 px-6">
        <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-lg">
          <p className="text-center text-indigo-600 font-semibold mb-4">
            Start your publishing journey with us
          </p>
          <h2 className="text-2xl font-bold text-gray-800 text-center">
            Express Your Interest
          </h2>
          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label htmlFor="primaryCountry" className="block text-sm font-medium text-gray-700">
                Your Country
              </label>
              <select
                id="primaryCountry"
                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={primaryCountry}
                onChange={(e) => setPrimaryCountry(e.target.value)}
              >
                <option value="">Select country</option>
                {countries.map((c) => (
                  <option key={c.cca3} value={c.name.common}>
                    {c.name.common}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="secondaryCountry" className="block text-sm font-medium text-gray-700">
                Desired Publication Country
              </label>
              <select
                id="secondaryCountry"
                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={secondaryCountry}
                onChange={(e) => setSecondaryCountry(e.target.value)}
              >
                <option value="">Select country</option>
                {countries.map((c) => (
                  <option key={c.cca3 + '-2'} value={c.name.common}>
                    {c.name.common}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                Message / Statement of Interest
              </label>
              <textarea
                id="message"
                rows="4"
                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Tell us about your vision or community..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-3 rounded text-lg font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              Start Your Publishing Journey
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
